import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ACTIONS_UPDATE_EMERGENCY_HOME_VISIT_ONLINE } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const updateEmergencyHomeVisitOnlineStatus = createAsyncThunk(
  ACTIONS_UPDATE_EMERGENCY_HOME_VISIT_ONLINE.update_midnight_home_visit_online,
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.put(
        `${process.env.REACT_APP_API_URL}${APP_PATH.emergencyHomeVisitOnline}`,
        payload,
      );

      if (response?.data?.status === true || response?.status === 200) {
        const message = getLocalizedMessage(response, i18n);
        toast.success(message);
        return response.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Update midnight home visit online status error:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(error?.response?.data || message);
    }
  },
);
